import { render, staticRenderFns } from "./Page-Profiles.vue?vue&type=template&id=3e057a40&"
import script from "./Page-Profiles.vue?vue&type=script&lang=js&"
export * from "./Page-Profiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports